export default [
  {
    path: 'category-subject',
    name: 'category-subject',
    component: () => import('@/views/pages/category-subject/CategorySubject.vue'),
    meta: {
      pageTitle: 'Category Subject',
      breadcrumb: [
        {
          text: 'Category Subject',
          active: true,
        },
      ],
      resource: 'CategorySubject',
    },
  },
]
